import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from "../Api";
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const [status, setStatus] = useState('success');
  const [message, setMessage] = useState('');
  const [countdown, setCountdown] = useState(3);
  const location = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {
  //   const verifyPayment = async () => {
  //     try {
  //       // Get session_id from URL query parameters
  //       const params = new URLSearchParams(location.search);
  //       const sessionId = params.get('session_id');
        
  //       console.log('Session ID from URL:', sessionId);
        
  //       if (!sessionId) {
  //         setStatus('error');
  //         setMessage('No session ID found. Please contact support if you completed the payment.');
  //         return;
  //       }

  //       // Use api instance instead of fetch
  //       console.log('Sending request to verify payment with session ID:', sessionId);
  //       const response = await api.get(`/api/web/payment-success?session_id=${sessionId}`, {
  //         headers: {
  //           'accept': 'text/plain',
  //         },
  //       });

  //       console.log('Payment verification response:', response.data);

  //       // Handle response data (it might be a string or object)
  //       let responseData = response.data;
        
  //       // If response.data is a string, try to parse it
  //       if (typeof responseData === 'string') {
  //         try {
  //           responseData = JSON.parse(responseData);
  //         } catch (e) {
  //           // If parsing fails, keep it as string
  //           console.log('Response is plain text:', responseData);
  //         }
  //       }

  //       // Check if payment was successful
  //       if (responseData && responseData.success === true) {
  //         setStatus('success');
  //         setMessage(responseData.message || 'Payment successful! Your subscription has been activated.');
  //       } 
  //       // Check if response is a plain text success message
  //       else if (typeof responseData === 'string' && 
  //                (responseData.includes('success') || responseData.includes('Payment successful'))) {
  //         setStatus('success');
  //         setMessage('Payment successful! Your subscription has been activated.');
  //       }
  //       else {
  //         setStatus('error');
  //         setMessage(responseData?.message || responseData || 'Payment verification failed');
  //       }
  //     } catch (error) {
  //       console.error('Payment verification error:', error);
        
  //       // Handle different error scenarios
  //       if (error.response) {
  //         // Server responded with error status
  //         console.error('Error response:', error.response.data);
          
  //         // Try to parse error response
  //         let errorData = error.response.data;
  //         if (typeof errorData === 'string') {
  //           try {
  //             errorData = JSON.parse(errorData);
  //           } catch (e) {
  //             // Keep as string
  //           }
  //         }
          
  //         setMessage(errorData?.message || errorData || 'Payment verification failed on server. Please contact support.');
  //       } else if (error.request) {
  //         // Request was made but no response
  //         setMessage('Network error. Please check your connection and try again.');
  //       } else {
  //         // Something else happened
  //         setMessage('An unexpected error occurred. Please contact support.');
  //       }
  //       setStatus('error');
  //     }
  //   };

  //   verifyPayment();
  // }, [location]);

  // Countdown timer for auto-redirect
  useEffect(() => {
    if (status === 'success') {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate('/plans');
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [status, navigate]);

  const handleBackToPlans = () => {
    navigate('/plans');
  };

  const handleRetry = () => {
    navigate('/plans');
  };

  return (
    <div className="payment-success-container">
      {status === 'loading' && (
        <div className="payment-status loading">
          <div className="spinner-large"></div>
          <h2>Verifying Your Payment...</h2>
          <p>Please wait while we confirm your subscription</p>
          <p className="note">Do not close this window</p>
        </div>
      )}

      {status === 'success' && (
        <div className="payment-status success">
          <div className="success-icon">✓</div>
          <h2>Payment Successful!</h2>
          <p>{message}</p>
          <p className="redirect-message">Redirecting to plans page in {countdown} seconds...</p>
          <button onClick={handleBackToPlans} className="back-button">
            Back to Plans Now
          </button>
        </div>
      )}

      {status === 'error' && (
        <div className="payment-status error">
          <div className="error-icon">!</div>
          <h2>Payment Verification Failed</h2>
          <p>{message}</p>
          <div className="error-actions">
            <button onClick={handleRetry} className="retry-button">
              Try Again
            </button>
            <button onClick={handleBackToPlans} className="back-button-secondary">
              Back to Plans
            </button>
          </div>
          <p className="support-note">
            If you were charged but see this error, please contact support with your payment reference.
          </p>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;